import apiClient, { type PagedResponse } from '../../client'
import type {
  RoleItem,
  CreateRoleRequest,
  UpdateRoleRequest,
  GetRolesParams,
} from '../../models/maestros.models'

const BASE_PATH = '/maestros/roles'

export const rolesCatalogService = {
  async getAll(params?: GetRolesParams): Promise<PagedResponse<RoleItem>> {
    return apiClient.get<PagedResponse<RoleItem>>(BASE_PATH, params)
  },
  async getById(id: string): Promise<RoleItem> {
    return apiClient.get<RoleItem>(`${BASE_PATH}/${id}`)
  },
  async create(data: CreateRoleRequest): Promise<RoleItem> {
    return apiClient.post<RoleItem, CreateRoleRequest>(BASE_PATH, data)
  },
  async update(id: string, data: UpdateRoleRequest): Promise<RoleItem> {
    return apiClient.put<RoleItem, UpdateRoleRequest>(`${BASE_PATH}/${id}`, data)
  },
  async delete(id: string): Promise<void> {
    return apiClient.delete<void>(`${BASE_PATH}/${id}`)
  },
}
